import type { NextPage } from 'next'
import Head from 'next/head'
import { Sobre } from 'src/views'

const SobrePage: NextPage = () => {
  return (
    <>
      <Head>
        <meta charSet="UTF-8" />

        <title>Sobre - Crédito One</title>

        <meta
          property="og:description"
          content="Saiba mais sobre quem somos e nossos produtos. Estamos aqui para criar uma nova experiência no mercado de crédito."
        />
        <meta property="og:type" content="website" />
        <meta property="og:locale" content="pt_BR" />
        <meta property="og:site_name" content="Crédito One" />
        <meta property="og:title" content="Sobre - Crédito One" />
        <meta
          name="description"
          content="Saiba mais sobre quem somos e nossos produtos. Estamos aqui para criar uma nova experiência no mercado de crédito."
        />
        <meta
          property="og:image"
          content="https://uploads-ssl.webflow.com/5fb18514177e609c5101c5b2/61aa78267b898128a13bbb31_open%20graph.png"
        />
        <link rel="icon" href="/favicon.ico" />
        
      </Head>
      <Sobre />
    </>
  )
}

export default SobrePage
